import React from'react';
import { AlertTriangle, RefreshCw } from'lucide-react';

/**
 * Error boundary for individual widgets/sections.
 * Catches rendering errors so one broken chart doesn't take down the entire page.
 */
export default class ErrorBoundary extends React.Component {
 constructor(props) {
 super(props);
 this.state = { hasError: false, error: null };
 }

 static getDerivedStateFromError(error) {
 return { hasError: true, error };
 }

 componentDidCatch(error, errorInfo) {
 console.error(`ErrorBoundary [${this.props.name ||'widget'}]:`, error, errorInfo);
 }

 handleRetry = () => {
 this.setState({ hasError: false, error: null });
 };

 render() {
 if (this.state.hasError) {
 return (
 <div className="flex flex-col items-center justify-center p-6 rounded-xl border border-red-200 bg-red-50/50 text-center">
 <AlertTriangle className="w-8 h-8 text-red-400 mb-2" />
 <p className="text-sm font-medium text-red-600 mb-1">
 {this.props.name ?`${this.props.name} failed to load` :'Something went wrong'}
 </p>
 <p className="text-xs text-red-500/70 mb-3 max-w-xs">
 {this.state.error?.message ||'An unexpected error occurred'}
 </p>
 <button
 onClick={this.handleRetry}
 className="flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium rounded-lg bg-red-100 text-red-700 hover:bg-red-200 transition"
 >
 <RefreshCw className="w-3 h-3" /> Retry
 </button>
 </div>
 );
 }

 return this.props.children;
 }
}
